import { FunctionComponent } from 'react';

import CompanyCard from 'components/content/blocks/CompanyCard';

import StyledComponent from './styles';
import { Props } from './types';

const SectionCompaniesCards: FunctionComponent<Props> = ({
    translations,
    companies,
}) => {
    return (
        <StyledComponent className="section-companies">
            {translations?.headline && (
                <div className="headline">
                    <h2>
                        {translations?.headline}
                    </h2>
                </div>
            )}
            <div className="companies">
                {companies?.elements?.map((company, idx) => (
                    <CompanyCard
                        key={company?.id || idx}
                        company={company}
                        translations={{
                            ctaButton: translations?.courseCtaButton,
                            alreadyScheduledButton: translations?.alreadyScheduledButton,
                        }}
                    />
                ))}
            </div>
        </StyledComponent>
    );
};

export default SectionCompaniesCards;
